import { GET, POST } from "./api.js";

export const emailNotification = {
    email: ( data ) => POST( `/email-notifications/license-renovation-message`, data)    
}